import saveAs from "file-saver";
import { TFunction } from "i18next";
import * as XLSX from 'xlsx';
import { EditableTableItem } from ".";


export const getHeaders = (t: TFunction) => [
  t('counting.lotStr'),
  t('product.code'),
  t('counting.count'),
];
export const generateTemplate = (t: TFunction) => {
  // 获取表头
  const headers = getHeaders(t);

  // 工作表数据（仅表头）
  const worksheetData = [headers];

  // 创建工作表
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  // 设置列宽
  worksheet['!cols'] = [
    { wch: 34 },  // 批次号
    { wch: 20 },  // 编码
    { wch: 15 },  // 数量
  ];

  // 创建工作簿
  const workbook = XLSX.utils.book_new();
  const sheetName = t('counting.downloadTemplate');
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  // 生成Excel文件并下载
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const dataBlob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  });

  const fileName = `${t('counting.downloadTemplate')}.xlsx`;
  saveAs(dataBlob, fileName);
};
/**
 * 获取单元格值并trim
 */
const getCellValue = (row: any[], index: number): string => {
  if (row[index] === undefined || row[index] === null) return '';
  return String(row[index]).trim();
};
//解析表格
export const parseData = (file: File, t: TFunction): Promise<EditableTableItem[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = e.target?.result;
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // 解析为二维数组
        const jsonData = XLSX.utils.sheet_to_json<string[]>(worksheet, { header: 1 });

        if (!jsonData || jsonData.length === 0) {
          reject(new Error('invalid'));
          return;
        }

        // 验证表头
        const headers = jsonData[0];
        const expectedHeaders = getHeaders(t);
        const isValidHeader = expectedHeaders.every((header, index) => header === headers[index]);
        if (!isValidHeader) {
          reject(new Error('invalid'));
          return;
        }

        // 解析数据行（跳过表头）
        const result: EditableTableItem[] = [];
        for (let i = 1; i < jsonData.length; i++) {
          const row = jsonData[i];
          if (!row || row.length === 0) continue;
          let count = Number(getCellValue(row, 2));
          result.push({
            lotStr: getCellValue(row, 0),
            productCode: getCellValue(row, 1),
            counting: !!!count ? null : count,
          });
        }

        resolve(result.filter(item => !!item.productCode && item.counting !== 0));
      } catch {
        reject(new Error('invalid'));
      }
    };
    reader.onerror = () => reject(new Error('invalid'));
    reader.readAsArrayBuffer(file);
  });
};